module.exports = __webpack_public_path__ + "img/booking-hero-6da2a13.jpg";